let toasts = []
const listeners = new Set()

function emit() {
  listeners.forEach((listener) => listener())
}

let nextId = 1

function push(variant, title, options = {}) {
  const id = nextId++
  const { description, duration = 4000 } = options
  toasts = [{ id, variant, title, description, duration }, ...toasts]
  emit()
  return id
}

function dismiss(id) {
  toasts = toasts.filter((t) => t.id !== id)
  emit()
}

export const toastStore = {
  subscribe(listener) {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
  getSnapshot() {
    return toasts
  },
  dismiss,
}

export const toast = {
  success: (title, options) => push('success', title, options),
  error: (title, options) => push('error', title, options),
  info: (title, options) => push('info', title, options),
  alert: (title, options) => push('alert', title, options),
  dismiss,
}
